import React, { useState, useRef, useEffect, useMemo, useCallback } from "react"
import {
  MapContainer,
  TileLayer,
  Marker,
  Popup,
  FeatureGroup,
  Polygon,
} from "react-leaflet"
import L from "leaflet"
import { EditControl } from "react-leaflet-draw"
import "leaflet/dist/leaflet.css"
import { useLeafletContext } from '@react-leaflet/core'

import { useLocation } from "react-router-dom"
import { useGetGTSurveyInspectionQuery } from "./RiskManagementApiSlice";

const markerIcon = new L.Icon({
  iconUrl: require("./marker4.jpg"),
  iconSize: [24, 35],
  iconAnchor: [22, 94],
  popupAnchor: [-3, -76],
  shadowSize: [20, 25],
  shadowAnchor: [22, 94]
})

function getBounds(props) {
    return L.latLng(props.center).toBounds(props.size)
}
function Square(props) {
    const context = useLeafletContext()
    const squareRef = useRef()
    const propsRef = useRef(props)

    useEffect(() => {

        squareRef.current = new L.Rectangle(getBounds(props))
        const container = context.layerContainer || context.map
        container.addLayer(squareRef.current)

        return () => {
            container.removeLayer(squareRef.current)
        }
    }, [])

    useEffect(() => {
        if (
            props.center !== propsRef.current.center ||
            props.size !== propsRef.current.size
        ) {
            squareRef.current.setBounds(getBounds(props))
        }
      
        if (props.bounds.length >= 1){
            context.map.fitBounds(props.bounds)
        }
        propsRef.current = props
        
    }, [props.center, props.size, props.bounds])

    return null
}

const RiskManagementGtPointDetailViewLatLongMap = ({latLongData}) => {
  
  const [PlotsMarker, setPlotsMarker] = useState([])
  const [showPlots, setPlotsBounds] = useState([])


 
  const [latdata, setlatdata] = useState([])
  



  const [center, setCenter] = useState([28.5769735, 77.317138])
  
 
 
  

  

  useEffect(() => {
    var tempPlots=[];
    if (Array.isArray(latLongData)) {
        setlatdata(latLongData)
        latLongData.map((item)=>{
            if(item.lat&&item.long)
            {
             tempPlots.push([item.lat,item.long])
            }

    })
    setPlotsBounds(tempPlots)
    }
   
   
  }, [latLongData])

  const ZOOM_LEVEL = 6


 
  




 
  

  
  
 
  return (
    <>
   
      <div className="row">
       
          <div className="col text-center">
         
              <div className="col">
                <MapContainer center={center} zoom={ZOOM_LEVEL} style={{height:"50vh",width:"100%"}}>
                
                <TileLayer
                url="http://mt0.google.com/vt/lyrs=y&hl=en&x={x}&y={y}&z={z}"
                attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                 />
                  <Square center={center} size={0} bounds={showPlots} />

                      {latLongData?
                        <>
                        {latLongData.map((item)=>{
                           
                        return(
                           <Marker
                           position={[item.lat,item.long]}
                           icon={markerIcon}
                         >
                      
                         </Marker>
                        )
                       }
                       )}
                        
                        </>
                   :"" }

                 
                </MapContainer>
                </div>
          </div>
       
      </div>
    </>
  )
}

export default RiskManagementGtPointDetailViewLatLongMap
